var map = {
  "./cs.json": [
    "dd0",
    [
      "7m"
    ]
  ],
  "./en.json": [
    "SQ",
    [
      461
    ]
  ],
  "./pl.json": [
    "kz",
    [
      "e4"
    ]
  ],
  "./ru.json": [
    "Sd",
    [
      "sx"
    ]
  ],
  "./tr.json": [
    "Ht",
    [
      "du"
    ]
  ],
  "./ja.json": [
    "F3v",
    [
      "3g"
    ]
  ],
  "./zh.json": [
    "OY",
    [
      "8u"
    ]
  ],
  "./pt-br.json": [
    "Tv",
    [
      "x6y"
    ]
  ],
  "./de.json": [
    "CVF",
    [
      "w4"
    ]
  ],
  "./es.json": [
    "uq0",
    [
      "8n"
    ]
  ],
  "./fr.json": [
    "YH",
    [
      "eif"
    ]
  ],
  "./it.json": [
    "MZw",
    [
      "eh"
    ]
  ],
  "./ko.json": [
    "b1T",
    [
      5
    ]
  ],
  "./pt.json": [
    "gS",
    [
      "i5"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "Lj";
module.exports = __rspack_async_context;
